import { useState } from 'react';

import { LoginFooter, LoginLogo, LoginReviews } from '@/components/login';
import { LoginAuthOptions } from '@/components/login/LoginAuthOptions';
import { LoginPasswordlessConfirm } from '@/components/login/LoginPasswordlessConfirm';
import { LoginPasswordlessSend } from '@/components/login/LoginPasswordlessSend';
import { LoginTraditional } from '@/components/login/LoginTraditional';
import { getLoginServerSideProps } from '@/lib/get-static-props/login';
import { isProdOrPreview } from '@/lib/vercel-env';
import { LoginStage } from '@/models/login.model';
import type { YotpoReview } from '@/pages/api/yotpo';

interface LoginProps {
  reviews: YotpoReview[];
}
export const getServerSideProps = getLoginServerSideProps;

const Login = ({ reviews }: LoginProps) => {
  const [loginStage, setLoginStage] = useState<LoginStage>(
    isProdOrPreview() ? LoginStage.passwordLessSend : LoginStage.emailPassword
  );
  const [phone, setPhone] = useState<string | null>(null);

  const renderStage = () => {
    switch (loginStage) {
      case LoginStage.emailPassword:
        return <LoginTraditional />;
      case LoginStage.passwordLessSend:
        return <LoginPasswordlessSend setLoginStage={setLoginStage} setPhone={setPhone} />;
      case LoginStage.passwordLessConfirm:
        return <LoginPasswordlessConfirm phone={phone} setLoginStage={setLoginStage} />;
    }
  };

  return (
    <div className="flex min-h-screen flex-col bg-white text-center lg:flex-row">
      <div className="z-10 flex-1">
        <div className="mx-auto flex h-full max-w-[560px] flex-col justify-center p-5 pb-14 lg:p-10">
          <LoginLogo />
          <div className="mb-5 mt-8 grow lg:mt-0 lg:grow-0">
            <h1 className="text-3xl font-light">Log In</h1>
            <div className="min-h-[244px]">{renderStage()}</div>
          </div>
          <LoginAuthOptions loginStage={loginStage} setLoginStage={setLoginStage} />
          <LoginFooter />
        </div>
      </div>
      <LoginReviews reviews={reviews} />
    </div>
  );
};

export default Login;
